import { DOMAttributes, FocusableElement } from "@react-types/shared"
import { AnimatePresence, motion } from "framer-motion"
import React, { PropsWithChildren } from "react"
import { Text, TextContext, useContextProps } from "react-aria-components"

import { cn } from "@/utilities/etc"

const FieldError = React.forwardRef(
  (
    props: PropsWithChildren<DOMAttributes<FocusableElement>>,
    ref: React.ForwardedRef<HTMLElement>
  ) => {
    ;[props, ref] = useContextProps(
      { ...props, slot: "errorMessage" },
      ref,
      TextContext
    )
    const classes = cn("body--2", "medium", props.className)
    return (
      <AnimatePresence>
        {props.children && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "fit-content" }}
            exit={{ opacity: 0, height: 0 }}
            className="field--error"
          >
            <Text {...props} ref={ref} className={classes}>
              {props.children}
            </Text>
          </motion.div>
        )}
      </AnimatePresence>
    )
  }
)

export default FieldError
